import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RichTextEditor from "@Shared/utils/rich-text-editor";
import HTMLTextEvaluationMixin from "@Shared/utils/application-mixins/html-text-evaluation-mixin";
import TimelineCardFooter from "@Broker/@Modules/clients/board/client-profile/components/timeline/utils/timeline-card-footer.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { showBModal } from "@Shared/components/bootstrap/BModal";
import { showToast } from "@Shared/utils/constants";
import Err from "@Broker/@Routes/error";
import { mapActions, mapGetters } from "vuex";
import { DELETE_REFERRER_NOTE, EDIT_REFERRER_NOTE } from "@Broker/@Modules/clients/referrers/store/referrer-actions.ts";
import { REFERRER_CUSTOM_FIELDS_TAGS, REFERRER_CUSTOM_FIELDS_HINT_TAGS } from "@Broker/@Modules/clients/referrers/store/referrer-getters.ts";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ReferrerTimelineNote",
  components: {
    TimelineCardFooter,
    InlinePrompt,
    ProfileAvatar
  },
  mixins: [HTMLTextEvaluationMixin],
  props: {
    note: {
      type: String,
      required: true
    },
    id: {
      type: String,
      required: true
    },
    referrerId: {
      type: [String, Number],
      required: true
    },
    pinned: {
      type: Boolean,
      default: false
    },
    activityType: {
      type: String,
      required: true
    },
    creator: {
      type: Object,
      default: () => ({})
    },
    createdAt: {
      type: String,
      required: true
    },
    updatedAt: {
      type: String,
      required: true
    },
    disabledActions: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      sending: false,
      editing: false,
      noteDescription: this.note,
      labelValue: uuidv4()
    };
  },
  computed: _objectSpread(_objectSpread({}, mapGetters("ReferrerStore", [REFERRER_CUSTOM_FIELDS_TAGS, REFERRER_CUSTOM_FIELDS_HINT_TAGS])), {}, {
    noteDescriptionHTML() {
      return RichTextEditor.sanitizeHtml(this.noteDescription);
    },
    canSave() {
      return this.htmlToTextContent(this.noteDescription) !== "";
    },
    name() {
      const {
        givenName,
        familyName
      } = this.creator;
      return this.$options.filters.nameFormat(givenName, familyName);
    },
    notUpdatedYet() {
      return this.createdAt === this.updatedAt;
    },
    customFieldsTags() {
      return this.REFERRER_CUSTOM_FIELDS_TAGS(this.referrerId);
    },
    customFieldsHintsTags() {
      return this.REFERRER_CUSTOM_FIELDS_HINT_TAGS(this.referrerId);
    }
  }),
  watch: {
    note(val) {
      this.noteDescription = val;
    },
    editing(val) {
      this.$nextTick(() => {
        if (val) this.init();
        $(".note-codable").attr("id", `add-description-${this.labelValue}`);
        $("#foreColorPicker").attr("id", `foreColorPicker-${this.labelValue}`);
        $("#backColorPicker").attr("id", `backColorPicker-${this.labelValue}`);
      });
    },
    customFieldsTags: {
      deep: true,
      handler(value) {
        var _this$editor;
        (_this$editor = this.editor) == null ? void 0 : _this$editor.updateOptions({
          mergeTags: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    },
    customFieldsHintsTags: {
      deep: true,
      handler(value) {
        var _this$editor2;
        (_this$editor2 = this.editor) == null ? void 0 : _this$editor2.updateOptions({
          hints: defaults => {
            return [...defaults, ...value];
          }
        });
      }
    }
  },
  mounted() {
    this.$nextTick(() => $(this.$refs.tooltipAnchor).tooltip());
  },
  methods: _objectSpread(_objectSpread({}, mapActions("ReferrerStore", [DELETE_REFERRER_NOTE, EDIT_REFERRER_NOTE])), {}, {
    init() {
      const target = $(this.$refs.textarea);
      this.editor = new RichTextEditor(target, {
        airMode: true,
        height: "6vw",
        substitutionHints: true,
        showMergeTags: true,
        loadPreferences: false,
        mergeTags: defaults => {
          return [...defaults, ...this.customFieldsTags];
        },
        hints: defaults => {
          return [...defaults, ...this.customFieldsHintsTags];
        },
        callbacks: {
          onChange: this.handleEditorChange
        }
      });
    },
    handleEditorChange(_, content) {
      this.noteDescription = content;
    },
    editNote() {
      this.editing = true;
    },
    async handleEdit() {
      this.editing = false;
      this.noteDescription = this.editor.getHTML();
      try {
        await this.EDIT_REFERRER_NOTE({
          referrerId: this.referrerId,
          noteId: this.id,
          data: {
            note: this.noteDescription
          }
        });
        showToast("success", "referrerNoteUpdated");
      } catch (error) {
        this.noteDescription = this.note;
        Err.handle(error);
      }
    },
    async handleDelete() {
      try {
        await this.DELETE_REFERRER_NOTE({
          referrerId: this.referrerId,
          noteId: this.id
        });
        showToast("success", "referrerNoteDeleted");
      } catch (error) {
        Err.handle(error);
      }
    },
    handlePin(id, type, pinned) {
      this.$emit("pin", id, type, pinned);
    },
    openActivityConvertModal() {
      showBModal("referrer-activity-convert-modal", {
        id: this.id,
        activityType: this.activityType
      }, this);
    }
  })
});